import { RESTClient } from '@api/client';
import { API_URL } from './apiDictionary';
import { prepareUrl } from 'src/utils/routerHelpers';
import { UpdateQueryRequest } from '@restore/queries/queries.types';

export const getSiteUserQueries = (
  clinicalTrialId: string,
  siteId: string,
  filters?: { status?: string; patientCode?: string; sort?: string; page?: number; size?: number }
) => {
  return RESTClient.get(prepareUrl(API_URL.siteQueries, []), {
    headers: {
      'x-dynamika-clinical-trial-id': clinicalTrialId,
      'x-dynamika-site-id': siteId,
    },
    params: {
      page: filters?.page ? filters.page - 1 : 0,
      size: filters?.size ?? 10,
      ...(filters?.sort && { sort: filters.sort }),
      status: filters?.status || undefined,
      patientCode: filters?.patientCode || undefined,
    },
  });
};

export const getSiteUserQueryById = (
  queryId: string,
  clinicalTrialId: string,
  siteId: string
) => {
  return RESTClient.get(prepareUrl(API_URL.siteQueriesById, [queryId]), {
    headers: {
      'x-dynamika-clinical-trial-id': clinicalTrialId,
      'x-dynamika-site-id': siteId,
    },
  });
};

export const updateSiteUserQueryById = (
  queryId: string,
  clinicalTrialId: string,
  siteId: string,
  body: UpdateQueryRequest
) => {
  const requestData = {
    ...body,
    attachments: [],
  };

  const formData = new FormData();
  formData.append('request', new Blob([JSON.stringify(requestData)], { type: 'application/json' }));

  body.attachments.forEach((attachment) => {
    formData.append('attachments', attachment);
  });

  return RESTClient.put(prepareUrl(API_URL.siteQueriesById, [queryId]), formData, {
    headers: {
      'x-dynamika-clinical-trial-id': clinicalTrialId,
      'x-dynamika-site-id': siteId,
    },
  });
};
